import { getJson } from '../../auth/utils/getJson.js';

/** GET /api/version — returns the current OTM release information */
export function fetchVersion(signal) {
  return getJson('/api/version', { signal });
}
